module.exports = __webpack_public_path__ + "img/big_eye_redchart01.f384a880.jpg";